"use client";

import React, { useState } from "react";
import InfoIcon from "@/assets/icons/info.svg?react";
import { AppliedPromotionsType, Block } from "@/common/lib/types";
import { convertToHTML } from "@/utils/product.utils";
import { cn } from "@/lib/tailwind";
import RenderCurrencyInText from "../common/RenderCurrencyInText";
import { getPromotionBadgeName } from "@/apiUtils/commonUtils";

interface IProps {
  lang: "en" | "ar";
  promotions: AppliedPromotionsType[];
}

const ProductPromotion = ({ lang, promotions }: IProps) => {
  // Magrabi parity: show only the first available promotion badge on PDP.
  const promos = promotions?.slice(0, 1) ?? [];
  const [selected, setSelected] = useState(-1);

  const getPromotionDetails = (promotion: AppliedPromotionsType) => {
    let blocks: Block[] = [];
    if (lang === "ar") {
      const parsed = JSON.parse(promotion?.promotion?.translation?.description ?? "{}");
      blocks = parsed?.blocks ?? [];
    } else {
      blocks = promotion?.promotion?.description?.blocks ?? [];
    }
    return convertToHTML(blocks);
  };

  return (
    <div className="flex flex-col items-center gap-1 pt-1">
      {promos.map((item, idx) => {
        const promoName = getPromotionBadgeName(item?.promotion, lang);
        if (!promoName) return null;

        return (
          <div key={idx} className="flex w-full flex-1 items-center justify-start gap-2">
            <p className="text-sm font-semibold text-secondary-1">
              <RenderCurrencyInText text={promoName} />
            </p>
            {item?.promotion?.description && (
              <span className="relative">
                <InfoIcon
                  role="button"
                  className="w-5 text-tertiary-6"
                  onMouseEnter={() => setSelected(idx)}
                  onMouseLeave={() => setSelected(-1)}
                />
                <span
                  className={cn(
                    "absolute -top-6 w-[26rem] bg-white p-4 text-[0.8em] shadow-md transition-all ease-in ltr:left-6 rtl:right-6",
                    selected === idx ? "block" : "hidden"
                  )}
                >
                  <h3 className="py-1 font-semibold">
                    <RenderCurrencyInText text={promoName} />
                  </h3>
                  <div
                    className="text-tertiary-6"
                    dangerouslySetInnerHTML={{
                      __html: getPromotionDetails(item),
                    }}
                  />
                </span>
              </span>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default ProductPromotion;
